"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuMarker = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SubMenuMarker = styled_components_1.default.div `
  position: absolute;
  top: 7px;
  right: 10px;
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;

  border-left: 4px solid #000;
`;
//# sourceMappingURL=sub-menu-marker.js.map